import { Component, Inject, OnInit } from '@angular/core';
import { OktaAuth } from '@okta/okta-auth-js';
import { Router } from '@angular/router';
import { AuthenticationService, AuthenticationType } from '../../domain';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConsoleService } from '../../widgets/console.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { AuthResult } from '../../domain';

@Component({
	selector: 'app-custom-okta-callback',
	templateUrl: './custom-okta-callback.component.html',
	styleUrls: ['./custom-okta-callback.component.scss']
})
export class CustomOktaCallbackComponent implements OnInit {

	constructor(
		@Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
		private authSvc: AuthenticationService,
		private router: Router,
		private console: ConsoleService,
		private snackBar: MatSnackBar,
		private gaService: GoogleAnalyticsService
	) { }

	async ngOnInit(): Promise<void> {

		try {

			if (!this.oktaAuth.isLoginRedirect()) {
				this.console.warn('Not an Okta redirect, skipping token parse');
				this.router.navigate(['/login']);
				return;
			}

			const tokens = await this.oktaAuth.token.parseFromUrl();
			this.oktaAuth.tokenManager.setTokens(tokens.tokens);

			this.console.log('Okta Tokens received', tokens.tokens);

			const authResult: AuthResult = {
				accessToken: tokens.tokens.accessToken?.accessToken,
				idToken: tokens.tokens.idToken?.idToken,
				provider: AuthenticationType[AuthenticationType.Okta],
				employeeId: String(tokens.tokens.idToken?.claims?.["employeeid"] ?? ""),
				name: tokens.tokens.idToken?.claims?.name,
				email: tokens.tokens.idToken?.claims?.email,
				username: tokens.tokens.idToken?.claims?.preferred_username
			};

			const success = await this.authSvc.tryAuthenticate(authResult, AuthenticationType.Okta);

			if (success) {
				this.console.log('Backend Okta authentication successful');
				this.gaService.eventEmitter("Authentication Success", "Authentication", "Success");
			} else {
				this.snackBar.open("Login Not Successful", null, { duration: 6000 });
				this.router.navigate(['/login']);
			}
		} catch (error) {
			this.console.error('Error during Okta callback', error);
			this.snackBar.open("Login Not Successful", null, { duration: 6000 });
			this.router.navigate(['/login']);
		}
	}
}
